import _ from 'lodash'

export const SORT_METHODS_CLASS = ['dmpicon-sort-custom', 'dmpicon-sort-asc', 'dmpicon-sort-desc']

// legend color themes
// 注意: colors 里面 全部使用大写字符
const defaultKey = 'tech'
const defaultMobileKey = 'mobile_theme_1'

// 报告的默认主题
const defaultChartTheme = 'tech_blue'

// 配色方案表
export const COLOR_THEMES = {
  [defaultKey]: {
    name: '科技蓝',
    colors: ['rgba(65,223,227,1)', 'rgba(72,141,251,1)', 'rgba(0,178,255,1)', 'rgba(93,128,242,1)',
      'rgba(52,201,255,1)', 'rgba(78,164,255,1)', 'rgba(95,97,230,1)', 'rgba(33,178,226,1)',
      'rgba(142,252,255,1)', 'rgba(59,143,255,1)', 'rgba(34,199,255,1)', 'rgba(148,149,255,1)'],
    type: 0
  },
  gradBlue: {
    name: '蓝色渐变',
    colors: [
      ['rgba(57,232,237,1)', 'rgba(155,255,230,1)'], ['rgba(69,140,247,1)', 'rgba(85,245,255,1)'], ['rgba(0,178,255,1)', 'rgba(146,192,255,1)'], ['rgba(159,159,255,1)', 'rgba(81,121,241,1)'],
      ['rgba(52,201,255,1)', 'rgba(139,242,255,1)'], ['rgba(78,164,255,1)', 'rgba(152,255,250,1)'], ['rgba(95,97,230,1)', 'rgba(202,175,255,1)'], ['rgba(0,178,255,1)', 'rgba(146,222,255,1)'],
      ['rgba(105,212,219,1)', 'rgba(209,252,255,1)'], ['rgba(60,143,253,1)', 'rgba(139,224,255,1)'], ['rgba(34,199,255,1)', 'rgba(129,250,255,1)'], ['rgba(148,149,255,1)', 'rgba(216,199,255,1)']
    ],
    type: 1,
  },
  gradStandar: {
    name: '标准渐变',
    colors: [
      ['rgba(81,130,228,1)', 'rgba(184,208,255,1)'], ['rgba(247,203,74,1)', 'rgba(255,246,219,1)'], ['rgba(105,212,219,1)', 'rgba(195,251,255,1)'], ['rgba(155,204,102,1)', 'rgba(241,255,226,1)'],
      ['rgba(63,178,126,1)', 'rgba(207,255,233,1)'], ['rgba(248,141,72,1)', 'rgba(255,222,201,1)'], ['rgba(242,82,82,1)', 'rgba(255,208,208,1)'], ['rgba(206,98,214,1)', 'rgba(252,218,255,1)'],
      ['rgba(137,84,212,1)', 'rgba(227,207,255,1)'], ['rgba(81,180,241,1)', 'rgba(191,231,255,1)'], ['rgba(82,179,186,1)', 'rgba(190,251,255,1)'], ['rgba(212,45,107,1)', 'rgba(255,212,228,1)']
    ],
    type: 1,
  },
  simple: {
    name: '简洁明快',
    colors: ['rgba(81,130,228,1)', 'rgba(105,212,219,1)', 'rgba(247,203,74,1)', 'rgba(155,204,102,1)',
      'rgba(63,178,126,1)', 'rgba(248,141,72,1)', 'rgba(242,82,82,1)', 'rgba(206,98,214,1)',
      'rgba(137,84,212,1)', 'rgba(81,180,241,1)', 'rgba(81,179,187,1)', 'rgba(212,45,107,1)'],
    type: 0
  },
  fall: {
    name: '金秋宜人',
    colors: ['rgba(191,155,48,1)', 'rgba(46,88,110,1)', 'rgba(231,202,130,1)', 'rgba(175,115,75,1)',
      'rgba(64,102,180,1)', 'rgba(38,136,137,1)', 'rgba(192,151,27,1)', 'rgba(100,81,81,1)',
      'rgba(145,137,87,1)', 'rgba(64,116,97,1)', 'rgba(115,91,75,1)', 'rgba(158,142,101,1)'],
    type: 0
  },
  blue: {
    name: '深蓝海底',
    colors: ['rgba(74,114,201,1)', 'rgba(117,96,191,1)', 'rgba(120,169,242,1)', 'rgba(96,113,197,1)',
      'rgba(162,204,248,1)', 'rgba(137,160,211,1)', 'rgba(73,102,183,1)', 'rgba(72,156,226,1)',
      'rgba(71,184,226,1)', 'rgba(96,135,191,1)', 'rgba(105,212,219,1)', 'rgba(57,140,158,1)'],
    type: 0
  },
  // 炫彩白、炫彩蓝（名称和key待定）
  // colorful_white: {
  //   name: '炫彩白',
  //   colors: ['#5182DF', '#F6CB49', '#4FB37D', '#99CC65', '#F08D49', '#EC5252', '#CF62D7', '#8A53D3', '#5155B8', '#4FB3F1', '#67D4DB', '#D42F6B'],
  //   type: 0
  // },
  // colorful_blue: {
  //   name: '炫彩蓝',
  //   colors: ['#5182DF', '#F6CB49', '#4FB37D', '#99CC65', '#F08D49', '#EC5252', '#CF62D7', '#8A53D3', '#5155B8', '#4FB3F1', '#67D4DB', '#D42F6B'],
  //   type: 0
  // },
  // 渐变蓝（开发使用）
  gradual_blue: {
    name: '渐变蓝',
    colors: ['#297CBA', '#1f3a90', '#131568', '#0d1544', '#297cba', '#54c0d5', '#b3e2cf', '#dcedc8'],
    type: 0
  },
  small_colorful: {
    name: '小清新',
    colors: ['#08A58B', '#E6D8B7', '#D57B74', '#EAD133', '#5898FF', '#FF9D66', '#75C059', '#AE6FFF', '#F79BC9', '#925F5F'],
    type: 0
  },
}

export const MOBILE_COLOR_THEMES = {
  mobile_theme_1: {
    name: '简洁明快',
    colors: [
      'rgba(66,129,235,1)', 'rgba(140,207,85,1)', 'rgba(0,182,121,1)', 'rgba(255,203,25,1)',
      'rgba(255,134,50,1)', 'rgba(255,65,74,1)', 'rgba(222,86,220,1)', 'rgba(147,76,220,1)',
      'rgba(81,83,191,1)', 'rgba(9,181,246,1)', 'rgba(46,215,221,1)', 'rgba(231,39,107,1)'
    ],
    type: 0,
  },
  mobile_theme_2: {
    name: '商务蓝',
    colors: [
      'rgba(0,107,201,1)', 'rgba(255,125,0,1)', 'rgba(0,171,229,1)', 'rgba(0,126,147,1)',
      'rgba(73,94,182,1)', 'rgba(193,135,23,1)', 'rgba(51,141,178,1)', 'rgba(80,202,247,1)',
      'rgba(255,188,148,1)', 'rgba(176,209,224,1)', 'rgba(219,227,135,1)', 'rgba(116,174,200,1)'
    ],
    type: 0,
  },
  mRed: {
    name: '古典红',
    colors: [
      'rgba(164,60,48,1)', 'rgba(90,99,67,1)', 'rgba(155,144,73,1)', 'rgba(228,208,152,1)',
      'rgba(239,149,105,1)', 'rgba(166,72,36,1)', 'rgba(237,72,61,1)', 'rgba(247,124,65,1)',
      'rgba(228,167,41,1)', 'rgba(195,168,102,1)', 'rgba(176,195,102,1)', 'rgba(195,102,130,1)'
    ],
    type: 0,
  },
  mPink: {
    name: '优雅粉紫',
    colors: [
      'rgba(118,93,180,1)', 'rgba(176,93,177,1)', 'rgba(214,194,221,1)', 'rgba(173,151,204,1)',
      'rgba(227,162,217,1)', 'rgba(177,93,130,1)', 'rgba(146,93,180,1)', 'rgba(151,158,204,1)',
    ],
    type: 0,
  },
  mGradStandar: {
    name: '标准渐变',
    colors: [
      ['rgba(81,130,228,1)', 'rgba(184,208,255,1)'], ['rgba(247,203,74,1)', 'rgba(255,246,219,1)'], ['rgba(105,212,219,1)', 'rgba(195,251,255,1)'], ['rgba(155,204,102,1)', 'rgba(241,255,226,1)'],
      ['rgba(63,178,126,1)', 'rgba(207,255,233,1)'], ['rgba(248,141,72,1)', 'rgba(255,222,201,1)'], ['rgba(242,82,82,1)', 'rgba(255,208,208,1)'], ['rgba(206,98,214,1)', 'rgba(252,218,255,1)'],
      ['rgba(137,84,212,1)', 'rgba(227,207,255,1)'], ['rgba(81,180,241,1)', 'rgba(191,231,255,1)'], ['rgba(82,179,186,1)', 'rgba(190,251,255,1)'], ['rgba(212,45,107,1)', 'rgba(255,212,228,1)']
    ],
    type: 1,
  },
  mDataBlue: {
    name: '数据蓝',
    colors: [
      '#7397EB', '#78DFCD', '#59B4ED', '#BFE1E6',
      '#A4CF85', '#5E77BF', '#A2ACF9', '#989FC2',
      '#8CABCE', '#C5D1E7', '#A5BCE7', '#6195F8',
    ],
    type: 0,
  },
  mVitalityBlue: {
    name: '活力蓝',
    colors: [
      '#5C9CE2', '#85D0AC', '#55BFDA', '#AAD990',
      '#5AADDF', '#CEE386', '#FBE182', '#F4B679',
      '#EB8776', '#D9708F', '#AA65B5', '#737ED6',
    ],
    type: 0,
  },
  mClassicBlue: {
    name: '经典蓝',
    colors: [
      '#556297', '#5FB7F9', '#7EC797', '#C9ECF2',
      '#6285DB', '#EDD44A', '#C28A68', '#EAE9F1',
      '#B5D57C', '#877EB8', '#B3BBD9', '#E6E4CC',
    ],
    type: 0,
  },
  mSkyBlue: {
    name: '天空蓝',
    colors: [
      '#5373C3', '#3A4EAD', '#83A9EC', '#ABCDF4',
      '#8EA0CF', '#4E67B1', '#5C9BDB', '#7263B8',
      '#65B6DE', '#6887BB',
    ],
    type: 0,
  }
}

// 报告主题
export const DASHBOARD_THEMES = {
  // 科技蓝
  tech_blue: {
    // 排序
    rank: 1,
    // 报告主题名称
    name: '科技蓝',
    // 报告的默认背景色
    dashboard_background: 'RGBA(15,24,47,1)',
    // 固定布局报告的默认背景色
    grid_dashboard_background: 'RGBA(15,24,47,1)',
    // 固定布局单图的默认背景色
    grid_dashboard_chart_background: 'transparent',
    // 报告的tooltip背景色
    tooltip_background: '#22325D',
    // 报告的tooltip额外css
    tooltip_extra_css: 'box-shadow: 2px 2px 8px #141E39;max-height: 450px;overflow-y:auto; transform: translateZ(1px);',
    // 报告的tooltip的标题颜色
    tooltip_title_color: '#FFFFFF',
    // 组件默认配色方案
    default_color_theme: {
      v: '1',
      themeKey: 'tech',
      customColors: [],
      affect: 0
    },
    grad_color_theme: {
      v: '1',
      themeKey: 'tech',
      customColors: [
        {
          value: ['#458CF7', '#55F5FF']
        }
      ],
      affect: 0
    },
    // 单图配色表
    chart_colors: {
      text: 'RGBA(167,199,250,1)',
      textOpacity: 'RGBA(167,199,250,0.7)',
      content: 'RGBA(65,223,227,1)',
      mapColor: 'amap://styles/6be95d38db9b467d4c873f87ecebb768',
      liquidColor: 'RGBA(65,223,227,1)',
      scatterColor: '#41DFE3',
      scatterAreaColor: 'RGBA(129,185,255,0.2)',
      scatterBorderColor: 'RGBA(72,141,251,1)',
      scatterDynamicColor: '#41DFE3',
      pointerColor: 'RGBA(129, 185, 255, 0.2)',
      tableHeaderColor: 'RGBA(48,76,135,1)',
      tableHandsonHeaderColor: 'RGBA(48,76,135,1)',
      tableSummaryColor: 'RGBA(48,76,135,1)',
      tableColor: 'RGBA(34,55,99,1)',
      tableRowColor: 'RGBA(15,24,47,1)',
      histogramColor: 'RGBA(148,199,255,0.15)',
      labelMapDimensionColor: 'RGBA(248,248,248,1)',
      labelMapNumberColor: 'RGBA(199,224,255,1)',
      labelMapValueColor: 'RGBA(248,248,248,1)',
      labelMapLineColor: 'RGBA(65,223,227,1)',
      labelMapHoverColor: 'RGBA(14,221,47,1)',
      labelMapBackgroundColor: 'RGBA(129,185,255,0.2)',
      labelMapBorderColor: 'RGBA(72,141,251,1)',
      labelMapCenterColor: 'RGBA(255,255,255,1)',
      labelMapCircleColor: 'RGBA(22,235,220,1)',
      candlestickTopColor: 'RGBA(69,140,247,1)',
      candlestickDownColor: 'RGBA(47,215,219,1)',
      timelineColor: 'RGBA(72,141,251,1)',
      tabColor: 'RGBA(65,223,227,1)',
      textWithoutAlpha: '#A7C7FA',
      tableHeaderColorWithoutAlpha: '#182648',
      tableColorWithoutAlpha: 'RGB(81,130,223)',
      tableRowWithoutAlpha: '#141E39',
      tableBorder: '#1A2A41',
      tableBg: 'RGB(15,24,47)',
      selectColor: 'RGBA(32,44,77,1)',
      legendColor: '#F7F8FA',
      gaugeColorPicker: 'RGBA(129,185,255,0.2)',
      searchFilterFontColor: '#A7C7FA',
      searchFilterDropdownBg: '#202C4D',
      textFontColor: '#24BCFA',
      labelFilterFontColor: '#A7C7FA',
      labelFilterDropdownBg: 'rgba(51,119,255,0.1)',
      numberFilterTextColor: '#A7C7FA',
      numberFilterNodeBackColor: '#303C5F',
      numberFilterLabelColor: '#A7C7FA',
      areaProvinceMapTextColor: '#FFF',
      areaProvinceMapBgColor: '#22325D'
    }
  },
  // 炫彩蓝
  colorful_blue: {
    rank: 2,
    name: '炫彩蓝',
    dashboard_background: 'RGBA(15,24,47,1)',
    // 固定布局报告的默认背景色
    grid_dashboard_background: 'RGBA(15,24,47,1)',
    // 固定布局单图的默认背景色
    grid_dashboard_chart_background: 'transparent',
    tooltip_background: '#22325D',
    tooltip_extra_css: 'box-shadow: 2px 2px 8px #141E39;max-height: 450px;overflow-y:auto; transform: translateZ(1px);',
    tooltip_title_color: '#FFFFFF',
    default_color_theme: {
      v: '1',
      themeKey: 'simple',
      customColors: [],
      affect: 0
    },
    chart_colors: {
      text: 'RGBA(176,211,255,0.8)',
      textOpacity: 'RGBA(176,211,255,0.5)',
      content: 'RGBA(255,255,255,1)',
      mapColor: 'amap://styles/6be95d38db9b467d4c873f87ecebb768',
      liquidColor: 'RGBA(81,130,223,1)',
      scatterColor: '#F6CB49',
      scatterAreaColor: 'RGBA(81,130,223,1)',
      scatterBorderColor: 'RGBA(19,31,57,1)',
      scatterDynamicColor: '#F6CB49',
      pointerColor: 'RGBA(167,199,250,0.6)',
      tableHeaderColor: 'RGBA(48,76,135,1)',
      tableHandsonHeaderColor: 'RGBA(48,76,135,1)',
      tableSummaryColor: 'RGBA(48,76,135,1)',
      tableColor: 'RGBA(34,55,99,1)',
      tableRowColor: 'RGBA(15,24,47,1)',
      histogramColor: 'RGBA(56,54,75,1)',
      labelMapDimensionColor: 'RGBA(199,224,255,1)',
      labelMapNumberColor: 'RGBA(199,224,255,1)',
      labelMapValueColor: 'RGBA(199,224,255,1)',
      labelMapLineColor: 'RGBA(246,203,73,1)',
      labelMapHoverColor: 'RGBA(38,139,219,1)',
      labelMapBackgroundColor: 'RGBA(81,130,223,1)',
      labelMapBorderColor: 'RGBA(19,21,57,1)',
      labelMapCenterColor: 'RGBA(240,141,73,1)',
      labelMapCircleColor: 'RGBA(246,203,73,1)',
      candlestickTopColor: 'RGBA(81,130,223,1)',
      candlestickDownColor: 'RGBA(246,203,73,1)',
      timelineColor: 'RGBA(81,85,184,1)',
      tabColor: 'RGBA(81,130,223,1)',
      textWithoutAlpha: '#A7C7FA',
      tableHeaderColorWithoutAlpha: '#324F8C',
      tableColorWithoutAlpha: 'RGB(81,130,223)',
      tableRowWithoutAlpha: '#192749',
      tableBorder: '#43577D',
      tableBg: 'RGB(15,24,47)',
      selectColor: 'RGBA(32,44,77,1)',
      gaugeColorPicker: 'RGBA(129,185,255,0.2)',
      legendColor: '#F7F8FA',
      searchFilterFontColor: '#A7C7FA',
      searchFilterDropdownBg: '#202C4D',
      textFontColor: '#24BCFA',
      labelFilterFontColor: '#A7C7FA',
      labelFilterDropdownBg: 'rgba(51,119,255,0.1)',
      numberFilterTextColor: '#A7C7FA',
      numberFilterNodeBackColor: '#303C5F',
      numberFilterLabelColor: '#A7C7FA',
      areaProvinceMapTextColor: '#FFF',
      areaProvinceMapBgColor: '#22325D'
    }
  },
  // 炫彩白
  colorful_white: {
    rank: 3,
    name: '炫彩白',
    dashboard_background: 'RGBA(255,255,255,1)',
    // 固定布局报告的默认背景色
    grid_dashboard_background: '#EBEDF2',
    // 固定布局单图的默认背景色
    grid_dashboard_chart_background: '#FFFFFF',
    tooltip_background: '#FFFFFF',
    tooltip_extra_css: 'box-shadow: 1px 1px 4px 2px rgba(0,0,0,0.10);max-height: 450px;overflow-y:auto; transform: translateZ(1px);',
    tooltip_title_color: '#555555',
    default_color_theme: {
      v: '1',
      themeKey: 'simple',
      customColors: [],
      affect: 0
    },
    chart_colors: {
      text: 'RGBA(46,46,46,1)',  // 文本颜色一
      textOpacity: 'RGBA(46,46,46,0.7)',
      content: 'RGBA(81,130,223,1)',  // 文本颜色二
      mapColor: 'amap://styles/normal',  // 地图专用
      liquidColor: 'RGBA(81,130,223,1)',
      scatterColor: '#F6CB49',  // 散点地图（K线图）专用
      scatterAreaColor: 'RGBA(81,130,223,1)',
      scatterBorderColor: 'RGBA(19,31,57,1)',
      scatterDynamicColor: '#F6CB49', // 散点地图动态颜色
      pointerColor: 'RGBA(229,229,229,1)',
      tableHeaderColor: 'RGBA(244,244,244,1)',
      tableHandsonHeaderColor: 'RGBA(244,244,244,1)',
      tableSummaryColor: 'RGBA(244, 244, 244, 1)',
      tableColor: 'RGBA(250,250,250,1)',
      tableRowColor: '#FFFFFF',
      histogramColor: 'RGBA(224,224,224,1)',
      labelMapDimensionColor: 'RGBA(51,51,51,1)',
      labelMapNumberColor: 'RGBA(51,51,51,1)',
      labelMapValueColor: 'RGBA(51,51,51,1)',
      labelMapLineColor: 'RGBA(246,203,73,1)',
      labelMapHoverColor: 'RGBA(81,130,223,1)',
      labelMapBackgroundColor: 'RGBA(81,130,223,1)',
      labelMapBorderColor: 'RGBA(19,31,57,1)',
      labelMapCenterColor: 'RGBA(240,141,73,1)',
      labelMapCircleColor: 'RGBA(246,203,73,1)',
      candlestickTopColor: 'RGBA(81,130,223,1)',
      candlestickDownColor: 'RGBA(246,203,73,1)',
      timelineColor: 'RGBA(81,130,223,1)',
      tabColor: 'RGBA(81,130,223,1)',
      textWithoutAlpha: '#2E2E2E',
      tableHeaderColorWithoutAlpha: 'RGBA(250,250,250,1)',
      tableColorWithoutAlpha: 'RGB(81,130,223)',
      tableRowWithoutAlpha: '#ffffff',
      tableBorder: 'RGBA(230,230,230,1)',
      tableBg: 'RGB(255,255,255)',
      tableScrollBar: 'RGBA(198, 200, 209, 0.5)',
      selectColor: 'RGBA(255,255,255,1)',
      gaugeColorPicker: '#EBECF1',
      legendColor: '#202437',
      searchFilterFontColor: '#202437',
      searchFilterDropdownBg: '#FFF',
      textFontColor: '#23B7F4',
      labelFilterFontColor: '#202437',
      labelFilterDropdownBg: 'rgba(247,248,250,1)',
      numberFilterTextColor: '#202437',
      numberFilterNodeBackColor: '#D8D8D8',
      numberFilterLabelColor: '#202437',
      areaProvinceMapTextColor: '#2E2E2E',
      areaProvinceMapBgColor: '#FFF'
    }
  },
  // 渐变蓝
  gradual_blue: {
    rank: 4,
    name: '渐变蓝',
    dashboard_background: 'RGBA(255,255,255,1)',
    // 固定布局报告的默认背景色
    grid_dashboard_background: '#EBEDF2',
    // 固定布局单图的默认背景色
    grid_dashboard_chart_background: '#FFFFFF',
    tooltip_background: '#FFFFFF',
    tooltip_extra_css: 'box-shadow: 1px 1px 4px 2px rgba(0,0,0,0.10);max-height: 450px;overflow-y:auto; transform: translateZ(1px);',
    tooltip_title_color: '#555555',
    default_color_theme: {
      v: '1',
      themeKey: 'gradual_blue',
      customColors: [],
      affect: 0
    },
    grad_color_theme: {
      v: '1',
      themeKey: 'gradual_blue',
      customColors: [
        {
          value: ['#54C0D5', '#1F3A90']
        }
      ],
      affect: 0
    },
    chart_colors: {
      text: 'RGBA(46,46,46,1)',
      textOpacity: 'RGBA(46,46,46,0.7)',
      content: 'RGBA(41,124,186,1)',
      mapColor: 'amap://styles/normal',
      liquidColor: 'RGBA(41,124,186,1)',
      scatterColor: '#DCEDC8',
      scatterAreaColor: 'RGBA(41,124,186,1)',
      scatterBorderColor: 'RGBA(19,21,104,1)',
      scatterDynamicColor: '#DCEDC8',
      pointerColor: 'RGBA(223,223,223,1)',
      tableHeaderColor: 'RGBA(244,244,244,1)',
      tableHandsonHeaderColor: 'RGBA(244,244,244,1)',
      tableSummaryColor: 'RGBA(244, 244, 244, 1)',
      tableColor: 'RGBA(250,250,250,1)',
      tableRowColor: '#FFFFFF',
      histogramColor: 'RGBA(229,229,229,1)',
      labelMapDimensionColor: 'RGBA(51,51,51,1)',
      labelMapNumberColor: 'RGBA(51,51,51,1)',
      labelMapValueColor: 'RGBA(51,51,51,1)',
      labelMapLineColor: 'RGBA(84,192,213,1)',
      labelMapHoverColor: 'RGBA(41,124,186,1)',
      labelMapBackgroundColor: 'RGBA(41,124,186,1)',
      labelMapBorderColor: 'RGBA(19,21,104,1)',
      labelMapCenterColor: 'RGBA(84,192,213,1)',
      labelMapCircleColor: 'RGBA(179,226,207,1)',
      candlestickTopColor: 'RGBA(84,192,213,1)',
      candlestickDownColor: 'RGBA(41,124,186,1)',
      timelineColor: 'RGBA(81,130,223,1)',
      tabColor: 'RGBA(41,124,186,1)',
      textWithoutAlpha: '#333333',
      tableHeaderColorWithoutAlpha: 'RGBA(250,250,250,1)',
      tableRowWithoutAlpha: '#ffffff',
      tableBorder: 'RGBA(230,230,230,1)',
      tableBg: 'RGB(255,255,255)',
      tableScrollBar: 'RGBA(198, 200, 209, 0.5)',
      selectColor: 'RGBA(255,255,255,1)',
      gaugeColorPicker: '#EBECF1',
      legendColor: '#202437',
      searchFilterFontColor: '#202437',
      searchFilterDropdownBg: '#FFF',
      textFontColor: '#23B7F4',
      labelFilterFontColor: '#202437',
      labelFilterDropdownBg: 'rgba(247,248,250,1)',
      numberFilterTextColor: '#202437',
      numberFilterNodeBackColor: '#D8D8D8',
      numberFilterLabelColor: '#202437',
      areaProvinceMapTextColor: '#2E2E2E',
      areaProvinceMapBgColor: '#FFF'
    }
  }
}

//echart图表默认边距
export const defaultGridMargin = { top: 40, right: 20, bottom: 20, left: 20 }

//设置报告主题
export function setDashboardTheme(dashboardTheme = defaultChartTheme) {
  if (_.keys(DASHBOARD_THEMES).indexOf(dashboardTheme) === -1) {
    dashboardTheme = defaultChartTheme
  }
  // 将默认配置挂在window下 作为全局变量
  // 此处只能包含【不受到单图样式配置控制的部分】或【可被覆盖的部分】
  window.DEFAULT_ECHARTS_OPTIONS = {
    grid: {
      ...defaultGridMargin,
      containLabel: true
    },
    tooltip: {
      backgroundColor: DASHBOARD_THEMES[dashboardTheme].tooltip_background,
      extraCssText: DASHBOARD_THEMES[dashboardTheme].tooltip_extra_css,
      titleColor: DASHBOARD_THEMES[dashboardTheme].tooltip_title_color
    }
  }
}

/*
* 返回当前设置的报告主题
*/
export function getCurrentDashboardTheme() {
  return window.__DASHBOARD_THEME
}

/*
 * 根据当前主题色返回dataZoom颜色
 */

export function getDataZoomColor() {
  const backgroundTheme = ['colorful_white', 'gradual_blue']

  return backgroundTheme.indexOf(getCurrentDashboardTheme()) !== -1 ? 'rgba(182,182,182,.6)' : 'rgba(38,86,134,.6)'
}

/*
* 根据key从报告主题的配色表中返回一个颜色
*/
export function getChartConfigColorByKey(key = 'main') {
  const currDashboardTheme = DASHBOARD_THEMES[getCurrentDashboardTheme()]

  if (currDashboardTheme && currDashboardTheme.chart_colors && currDashboardTheme.chart_colors[key]) {
    return currDashboardTheme.chart_colors[key]
  }
  return 'TRANSPARENT'
}

// 获取初始渐变角度
export const getDefaultGradAngle = (chartCode) => {
  // 默认90度
  const angle90charts = [
    'horizon_bar', 'horizon_bar_roll', 'horizon_stack_bar',
    'multiple_horizon_bar_mobile'
  ]

  if (angle90charts.indexOf(chartCode) > -1) {
    return 90
  }
  return 0
}

export function getAllColorThemes(gradient = true, terminal = '') {
  let COLORS_MAP = COLOR_THEMES
  if (terminal === 'mobile') {
    COLORS_MAP = MOBILE_COLOR_THEMES
  }
  if (!gradient) {
    // 过滤渐变色
    COLORS_MAP = _.pickBy(COLORS_MAP, theme => theme.type === 0)
  }
  return COLORS_MAP
}

export function getThemeByKey(themeKey, terminal) {
  if (terminal === 'mobile') {
    return MOBILE_COLOR_THEMES[themeKey] || MOBILE_COLOR_THEMES[defaultMobileKey]
  }
  return COLOR_THEMES[themeKey] || COLOR_THEMES[defaultKey]
}

// gradientDefaultAngle = 0垂直渐变
// 此方法用于chart sdk 自定义组件的
export function getColorFromTheme({ themeKey, customColors }, index, gradientDefaultAngle = 0, terminal = '') {
  let color = customColors && customColors[index] && customColors[index].value
  if (!color) {
    // 循环使用color
    const themeObj = getThemeByKey(themeKey, terminal)
    const len = themeObj.colors.length
    color = themeObj.colors[index % len]
  }
  // 渐变色有个磨人的角度
  if (Array.isArray(color) && (color[2] === undefined || color[2] === null)) {
    color = [...color]
    color[2] = gradientDefaultAngle
  }
  return color
}

// 弧度转换成echarts [x1, y1, x2, y2]
const _angelToPoints = function (radians) {
  const { cos, sin, PI } = Math
  const offset = PI / 2
  // 根据圆的方程
  return [
    (0.5 * cos(radians + offset)) + 0.5,
    (0.5 * sin(radians + offset)) + 0.5,
    (0.5 * cos(radians + PI + offset)) + 0.5,
    (0.5 * sin(radians + PI + offset)) + 0.5,
  ]
}

const _getParamFromAngle = function (angle) {
  return _angelToPoints(angle / 180 * Math.PI)
}
// 此方法用于chart sdk
// 生成普通颜色或者渐变色
export function getEchartColorFromTheme(echarts, legendTheme, index, gradientDefaultAngle = 0) {
  let color = getColorFromTheme(legendTheme, index, gradientDefaultAngle, '')
  if (Array.isArray(color)) {
    const angle = color[2]
    const param = _getParamFromAngle(angle)
    color = new echarts.graphic.LinearGradient(param[0], param[1], param[2], param[3], [{ offset: 0, color: color[0] }, { offset: 1, color: color[1] }])
  }
  return color
}

// 数据库需要把这个对象的 stringify
export function generateDefaultColorTheme(key) {
  const currDashboardTheme = DASHBOARD_THEMES[getCurrentDashboardTheme()]
  let defaultColorTheme = {
    v: '1',
    themeKey: defaultKey,
    customColors: [],
    affect: 0
  }

  // 获取单独设置的渐变样式
  if (key === 'gradColorTheme' && currDashboardTheme && currDashboardTheme.grad_color_theme) {
    defaultColorTheme = currDashboardTheme.grad_color_theme
  } else if (currDashboardTheme && currDashboardTheme.default_color_theme) {
    defaultColorTheme = currDashboardTheme.default_color_theme
  }

  return COLOR_THEMES[key] ? {
    v: '1',
    themeKey: key,
    customColors: [],
    affect: 0
  } : defaultColorTheme
}

// 是否同类型颜色（渐变色是数组、普通色是字符串）
const isSameColorType = (c0, c1) => typeof c0 === typeof c1

export function customColorAtIndex(colorTheme, { index, color, colName, formulaMode }) {
  // 需要统一自定义颜色, 不能混合使用, 删除不同类的自定义颜色
  colorTheme.customColors.forEach((colorObj, i) => {
    if (colorObj && !isSameColorType(colorObj.value, color)) {
      colorTheme.customColors[i] = undefined
    }
  })
  colorTheme.customColors[index] = {
    value: color,
    colName: colName || '',                  // 预留字段
    formulaMode: formulaMode || ''          // 预留字段
  }
  return colorTheme
}

// 此方法用于chart sdk
// 生成f2普通颜色或者渐变色
export function getF2ColorFromTheme(legendTheme, index, gradientDefaultAngle = 0) {
  let color = getColorFromTheme(legendTheme, index, gradientDefaultAngle, 'mobile')
  if (Array.isArray(color)) {
    const offset = -90
    const angle = color[2] + offset
    // https://www.yuque.com/antv/f2/canvas
    color = `l(${angle}) 0:${color[0]} 1:${color[1]}`
  }
  return color
}

// f2颜色解析
export const parseF2Color = (color) => {
  const f2GradColorReg = /l\((-?\d+)\)\s0:(rgba.*\))\s1:(rgba.*\))/g
  const result = f2GradColorReg.exec(color)
  let background = color
  let textColor = color
  if (result) {
    const offset = 90
    const angle = parseInt(result[1], 10) + offset
    const startColor = result[2]
    const endColor = result[3]
    background = `linear-gradient(${angle}deg, ${startColor}, ${endColor})`
    textColor = startColor
  }
  return {
    background,
    textColor
  }
}
